import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Row, Col, Card } from 'react-bootstrap';
import { getControlGestionList } from './utils/controlGestionConstants';
import SimpleControlGestionLayout from './components/SimpleControlGestionLayout';
import ControlDiario from './pages/ControlDiario';
import BusquedaGuias from './pages/BusquedaGuias';
import ControlSemanal from './pages/ControlSemanal';
import BusquedaMasivaGuias from './pages/BusquedaMasivaGuias';
import RutasPendientesRevision from './pages/RutasPendientesRevision';
import * as FaIcons from 'react-icons/fa';

const ControlGestion = () => {
  const history = useHistory();
  const location = useLocation();

  // Obtener la lista de opciones desde la configuración
  const controlGestionList = getControlGestionList();

  const handleOptionClick = (option) => {
    console.log(`Navegando a ${option.titulo}`, option);
    history.push(option.path);
  };

  // Determinar qué componente renderizar basado en la ruta actual
  const renderContent = () => {
    switch (location.pathname) {
      case '/control-gestion/control-diario':
        return <ControlDiario />;
      case '/control-gestion/busqueda-guias':
        return <BusquedaGuias />;
      case '/control-gestion/control-semanal':
        return <ControlSemanal />;
      case '/control-gestion/busqueda-masiva-guias':
        return <BusquedaMasivaGuias />;
      case '/control-gestion/rutas-pendientes-revision':
        return <RutasPendientesRevision />;
      default:
        // Mostrar las cards de opciones
        return (
          <SimpleControlGestionLayout
            title="Control de Gestión"
            subtitle="Gestiona y administra el control diario de operaciones y búsqueda de guías"
            icon={<FaIcons.FaChartLine />}
            iconColor="#667eea"
            showBackButton={false}
          >
            <Row>
              {controlGestionList.map((option) => (
                <Col xs={12} sm={6} md={4} lg={3} key={option.id} className="mb-4">
                  <Card
                    className="h-100"
                    onClick={() => handleOptionClick(option)}
                    style={{
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      border: '1px solid #dee2e6',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                    }}
                  >
                    <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                      <div
                        className="mb-3"
                        style={{
                          background: `linear-gradient(135deg, ${option.color} 0%, ${option.color}dd 100%)`,
                          width: '50px',
                          height: '50px',
                          borderRadius: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '20px',
                          color: 'white'
                        }}
                      >
                        {option.icon}
                      </div>
                      <Card.Title
                        as="h6"
                        className="mb-2 text-truncate w-100"
                        style={{
                          fontSize: '1rem',
                          fontWeight: '600',
                          color: '#212529'
                        }}
                      >
                        {option.titulo}
                      </Card.Title>
                      <Card.Text
                        className="text-muted small text-center"
                        style={{
                          fontSize: '0.85rem',
                          lineHeight: '1.3',
                          overflow: 'hidden',
                          display: '-webkit-box',
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: 'vertical',
                          color: '#6c757d'
                        }}
                      >
                        {option.descripcion}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </SimpleControlGestionLayout>
        );
    }
  };

  return renderContent();
};

export default ControlGestion;
